import axiosRest from '@aponder.top/axios-rest'

const baseURL = process.env.VUE_APP_PYTHON_API_URL

const rest = axiosRest(baseURL, {}, true)
const GET = 'GET'
const DELETE = 'DELETE'
// 注册
const user = rest("user")

// 登录
user.auth = user.make_plural_action("auth")
// 关键词
const keywords = rest('/keywords')
// 领域
const domains = rest('/domains')
// 网络态势
const knowledge = rest('/knowledge')
knowledge.analyze = knowledge.make_plural_action('analyze')//网络势态分析
knowledge.predict = knowledge.make_plural_action('predict')//网络势态预测
knowledge.serialize = knowledge.make_plural_action('serialize')//序列化攻击模式
knowledge.choose = knowledge.make_plural_action('choose')//选择攻击方式
knowledge.query = knowledge.make_plural_action('query')//单点炸开

const information = rest('information') // 查看列表
knowledge.information = knowledge.make_single_action(information)//获取信息

const vendor = rest('vendor')
knowledge.vendor = knowledge.make_plural_action(vendor, GET)//获取商品或产品

const version = rest('version')
knowledge.version = knowledge.make_plural_action(version)//获取版本

const management = rest('management')
knowledge.management = knowledge.make_plural_action(management)//图谱管理
// const extraction = rest('extraction')
knowledge.extraction = knowledge.make_plural_action('extraction', GET)//知识抽取管理

const controlled_nodes = rest('controlled_nodes')
knowledge.controlled_nodes = knowledge.make_plural_action(controlled_nodes)//更新可控守节点

// 关键指标
const key_index = rest('key_index')
// key_index.word_clouding = key_index.make_plural_action(word_clouding)//词云图

// 知识图谱
const knowledge_graph = rest('knowledge_graph')
knowledge_graph.init = knowledge_graph.make_plural_action("init")//初始化知识图谱
knowledge_graph.upload = knowledge_graph.make_plural_action("upload")//上传JSON文件
knowledge_graph.list_all = knowledge_graph.make_plural_action("list_all",GET) // 列出相应数量的节点
knowledge_graph.list_labels = knowledge_graph.make_plural_action("list_labels",GET)//列出所以标签
knowledge_graph.list_relationships = knowledge_graph.make_plural_action("list_relationships",GET)//列出所有关系
knowledge_graph.list_properties = knowledge_graph.make_plural_action("list_properties",GET)//列出所有属性
knowledge_graph.query_entities = knowledge_graph.make_plural_action("query_entities")// 查询实体
knowledge_graph.query_relationship = knowledge_graph.make_plural_action("query_relationship")// 查询关系
knowledge_graph.empty = knowledge_graph.make_plural_action("empty",GET) // 清空数据库
knowledge_graph.entity = knowledge_graph.make_plural_action("entity") // 创建、删除实体
knowledge_graph.deletentity = knowledge_graph.make_plural_action("entity",DELETE) // 创建、删除实体
knowledge_graph.relation = knowledge_graph.make_plural_action("relation") // 创建、删除关系
knowledge_graph.deleterelation = knowledge_graph.make_plural_action("relation",DELETE) // 创建、删除关系
knowledge_graph.properties = knowledge_graph.make_plural_action("properties") // 设置节点属性
knowledge_graph.export = knowledge_graph.make_plural_action("export",GET) // 导出JSON文件

// 态势分析
const situation = rest('situation')
situation.troops_deploy = situation.make_plural_action('troops_deploy') // 兵力部署
situation.fleet_insert = situation.make_plural_action('fleet_insert') // 舰队坐标插入
situation.fleet_get = situation.make_plural_action('fleet_get') // 航迹追踪

// 链接（仅限管理员操作）
const url = rest('url')
export default {
  keywords,
  domains,
  knowledge,
  user,
  key_index,
  knowledge_graph,
  situation,
  url
}